import { ApiError } from '@jq4race/api-client';
import { translateApiError, useTranslation } from '@jq4race/i18n';
import { cn } from '@jq4race/ui';
import { AlertTriangle } from 'lucide-react';

interface ErrorBannerProps {
  error: unknown;
  className?: string;
}

export function ErrorBanner({ error, className }: ErrorBannerProps) {
  const { t } = useTranslation();
  if (!error) return null;
  // Non-ApiError failures (unexpected throws) must not surface their raw text.
  const copy =
    error instanceof ApiError ? translateApiError(error, t) : t('apiErrors:codes.unknown');
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2 rounded-sm border border-destructive/60 bg-destructive/15 px-3 py-2',
        'text-[13px] font-medium text-destructive',
        className,
      )}
    >
      <AlertTriangle className="mt-0.5 size-4 text-destructive" />
      <span>{copy}</span>
    </div>
  );
}
